"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.weekData = void 0;
/* @generated */
// prettier-ignore
exports.weekData = {
  "001": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "AC": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "AD": {
    "firstDay": 1,
    "minimalDays": 4,
    "weekend": [6, 7]
  },
  "AE": {
    "firstDay": 6,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "AF": {
    "firstDay": 6,
    "minimalDays": 1,
    "weekend": [4, 5]
  },
  "AG": {
    "firstDay": 7,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "AI": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "AL": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "AM": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "AO": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "AQ": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "AR": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "AS": {
    "firstDay": 7,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "AT": {
    "firstDay": 1,
    "minimalDays": 4,
    "weekend": [6, 7]
  },
  "AU": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "AW": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "AX": {
    "firstDay": 1,
    "minimalDays": 4,
    "weekend": [6, 7]
  },
  "AZ": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "BA": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "BB": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "BD": {
    "firstDay": 7,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "BE": {
    "firstDay": 1,
    "minimalDays": 4,
    "weekend": [6, 7]
  },
  "BF": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "BG": {
    "firstDay": 1,
    "minimalDays": 4,
    "weekend": [6, 7]
  },
  "BH": {
    "firstDay": 6,
    "minimalDays": 1,
    "weekend": [5, 6]
  },
  "BI": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "BJ": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "BL": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "BM": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "BN": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "BO": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "BQ": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "BR": {
    "firstDay": 7,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "BS": {
    "firstDay": 7,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "BT": {
    "firstDay": 7,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "BV": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "BW": {
    "firstDay": 7,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "BY": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "BZ": {
    "firstDay": 7,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "CA": {
    "firstDay": 7,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "CC": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "CD": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "CF": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "CG": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "CH": {
    "firstDay": 1,
    "minimalDays": 4,
    "weekend": [6, 7]
  },
  "CI": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "CK": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "CL": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "CM": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "CN": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "CO": {
    "firstDay": 7,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "CP": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "CQ": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "CR": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "CU": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "CV": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "CW": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "CX": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "CY": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "CZ": {
    "firstDay": 1,
    "minimalDays": 4,
    "weekend": [6, 7]
  },
  "DE": {
    "firstDay": 1,
    "minimalDays": 4,
    "weekend": [6, 7]
  },
  "DG": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "DJ": {
    "firstDay": 6,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "DK": {
    "firstDay": 1,
    "minimalDays": 4,
    "weekend": [6, 7]
  },
  "DM": {
    "firstDay": 7,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "DO": {
    "firstDay": 7,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "DZ": {
    "firstDay": 6,
    "minimalDays": 1,
    "weekend": [5, 6]
  },
  "EA": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "EC": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "EE": {
    "firstDay": 1,
    "minimalDays": 4,
    "weekend": [6, 7]
  },
  "EG": {
    "firstDay": 6,
    "minimalDays": 1,
    "weekend": [5, 6]
  },
  "EH": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "ER": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "ES": {
    "firstDay": 1,
    "minimalDays": 4,
    "weekend": [6, 7]
  },
  "ET": {
    "firstDay": 7,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "FI": {
    "firstDay": 1,
    "minimalDays": 4,
    "weekend": [6, 7]
  },
  "FJ": {
    "firstDay": 1,
    "minimalDays": 4,
    "weekend": [6, 7]
  },
  "FK": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "FM": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "FO": {
    "firstDay": 1,
    "minimalDays": 4,
    "weekend": [6, 7]
  },
  "FR": {
    "firstDay": 1,
    "minimalDays": 4,
    "weekend": [6, 7]
  },
  "GA": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "GB": {
    "firstDay": 1,
    "minimalDays": 4,
    "weekend": [6, 7]
  },
  "GD": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "GE": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "GF": {
    "firstDay": 1,
    "minimalDays": 4,
    "weekend": [6, 7]
  },
  "GG": {
    "firstDay": 1,
    "minimalDays": 4,
    "weekend": [6, 7]
  },
  "GH": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "GI": {
    "firstDay": 1,
    "minimalDays": 4,
    "weekend": [6, 7]
  },
  "GL": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "GM": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "GN": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "GP": {
    "firstDay": 1,
    "minimalDays": 4,
    "weekend": [6, 7]
  },
  "GQ": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "GR": {
    "firstDay": 1,
    "minimalDays": 4,
    "weekend": [6, 7]
  },
  "GS": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "GT": {
    "firstDay": 7,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "GU": {
    "firstDay": 7,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "GW": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "GY": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "HK": {
    "firstDay": 7,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "HM": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "HN": {
    "firstDay": 7,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "HR": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "HT": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "HU": {
    "firstDay": 1,
    "minimalDays": 4,
    "weekend": [6, 7]
  },
  "IC": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "ID": {
    "firstDay": 7,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "IE": {
    "firstDay": 1,
    "minimalDays": 4,
    "weekend": [6, 7]
  },
  "IL": {
    "firstDay": 7,
    "minimalDays": 1,
    "weekend": [5, 6]
  },
  "IM": {
    "firstDay": 1,
    "minimalDays": 4,
    "weekend": [6, 7]
  },
  "IN": {
    "firstDay": 7,
    "minimalDays": 1,
    "weekend": [7]
  },
  "IO": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "IQ": {
    "firstDay": 6,
    "minimalDays": 1,
    "weekend": [5, 6]
  },
  "IR": {
    "firstDay": 6,
    "minimalDays": 1,
    "weekend": [5]
  },
  "IS": {
    "firstDay": 1,
    "minimalDays": 4,
    "weekend": [6, 7]
  },
  "IT": {
    "firstDay": 1,
    "minimalDays": 4,
    "weekend": [6, 7]
  },
  "JE": {
    "firstDay": 1,
    "minimalDays": 4,
    "weekend": [6, 7]
  },
  "JM": {
    "firstDay": 7,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "JO": {
    "firstDay": 6,
    "minimalDays": 1,
    "weekend": [5, 6]
  },
  "JP": {
    "firstDay": 7,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "KE": {
    "firstDay": 7,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "KG": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "KH": {
    "firstDay": 7,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "KI": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "KM": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "KN": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "KP": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "KR": {
    "firstDay": 7,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "KW": {
    "firstDay": 6,
    "minimalDays": 1,
    "weekend": [5, 6]
  },
  "KY": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "KZ": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "LA": {
    "firstDay": 7,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "LB": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "LC": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "LI": {
    "firstDay": 1,
    "minimalDays": 4,
    "weekend": [6, 7]
  },
  "LK": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "LR": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "LS": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "LT": {
    "firstDay": 1,
    "minimalDays": 4,
    "weekend": [6, 7]
  },
  "LU": {
    "firstDay": 1,
    "minimalDays": 4,
    "weekend": [6, 7]
  },
  "LV": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "LY": {
    "firstDay": 6,
    "minimalDays": 1,
    "weekend": [5, 6]
  },
  "MA": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "MC": {
    "firstDay": 1,
    "minimalDays": 4,
    "weekend": [6, 7]
  },
  "MD": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "ME": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "MF": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "MG": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "MH": {
    "firstDay": 7,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "MK": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "ML": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "MM": {
    "firstDay": 7,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "MN": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "MO": {
    "firstDay": 7,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "MP": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "MQ": {
    "firstDay": 1,
    "minimalDays": 4,
    "weekend": [6, 7]
  },
  "MR": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "MS": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "MT": {
    "firstDay": 7,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "MU": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "MV": {
    "firstDay": 5,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "MW": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "MX": {
    "firstDay": 7,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "MY": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "MZ": {
    "firstDay": 7,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "NA": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "NC": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "NE": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "NF": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "NG": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "NI": {
    "firstDay": 7,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "NL": {
    "firstDay": 1,
    "minimalDays": 4,
    "weekend": [6, 7]
  },
  "NO": {
    "firstDay": 1,
    "minimalDays": 4,
    "weekend": [6, 7]
  },
  "NP": {
    "firstDay": 7,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "NR": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "NU": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "NZ": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "OM": {
    "firstDay": 6,
    "minimalDays": 1,
    "weekend": [5, 6]
  },
  "PA": {
    "firstDay": 7,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "PE": {
    "firstDay": 7,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "PF": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "PG": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "PH": {
    "firstDay": 7,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "PK": {
    "firstDay": 7,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "PL": {
    "firstDay": 1,
    "minimalDays": 4,
    "weekend": [6, 7]
  },
  "PM": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "PN": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "PR": {
    "firstDay": 7,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "PS": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "PT": {
    "firstDay": 7,
    "minimalDays": 4,
    "weekend": [6, 7]
  },
  "PW": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "PY": {
    "firstDay": 7,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "QA": {
    "firstDay": 6,
    "minimalDays": 1,
    "weekend": [5, 6]
  },
  "RE": {
    "firstDay": 1,
    "minimalDays": 4,
    "weekend": [6, 7]
  },
  "RO": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "RS": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "RU": {
    "firstDay": 1,
    "minimalDays": 4,
    "weekend": [6, 7]
  },
  "RW": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "SA": {
    "firstDay": 7,
    "minimalDays": 1,
    "weekend": [5, 6]
  },
  "SB": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "SC": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "SD": {
    "firstDay": 6,
    "minimalDays": 1,
    "weekend": [5, 6]
  },
  "SE": {
    "firstDay": 1,
    "minimalDays": 4,
    "weekend": [6, 7]
  },
  "SG": {
    "firstDay": 7,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "SH": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "SI": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "SJ": {
    "firstDay": 1,
    "minimalDays": 4,
    "weekend": [6, 7]
  },
  "SK": {
    "firstDay": 1,
    "minimalDays": 4,
    "weekend": [6, 7]
  },
  "SL": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "SM": {
    "firstDay": 1,
    "minimalDays": 4,
    "weekend": [6, 7]
  },
  "SN": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "SO": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "SR": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "SS": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "ST": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "SV": {
    "firstDay": 7,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "SX": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "SY": {
    "firstDay": 6,
    "minimalDays": 1,
    "weekend": [5, 6]
  },
  "SZ": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "TA": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "TC": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "TD": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "TF": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "TG": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "TH": {
    "firstDay": 7,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "TJ": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "TK": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "TL": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "TM": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "TN": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "TO": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "TR": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "TT": {
    "firstDay": 7,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "TV": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "TW": {
    "firstDay": 7,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "TZ": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "UA": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "UG": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [7]
  },
  "UM": {
    "firstDay": 7,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "US": {
    "firstDay": 7,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "UY": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "UZ": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "VA": {
    "firstDay": 1,
    "minimalDays": 4,
    "weekend": [6, 7]
  },
  "VC": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "VE": {
    "firstDay": 7,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "VG": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "VI": {
    "firstDay": 7,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "VN": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "VU": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "WF": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "WS": {
    "firstDay": 7,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "XK": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "YE": {
    "firstDay": 7,
    "minimalDays": 1,
    "weekend": [5, 6]
  },
  "YT": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "ZA": {
    "firstDay": 7,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "ZM": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "ZW": {
    "firstDay": 7,
    "minimalDays": 1,
    "weekend": [6, 7]
  },
  "ZZ": {
    "firstDay": 1,
    "minimalDays": 1,
    "weekend": [6, 7]
  }
};